import { render, staticRenderFns } from "./FormerYearDepartmentList.vue?vue&type=template&id=7206b7be&scoped=true&"
import script from "./FormerYearDepartmentList.vue?vue&type=script&lang=js&"
export * from "./FormerYearDepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./FormerYearDepartmentList.vue?vue&type=style&index=0&id=7206b7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206b7be",
  null
  
)

export default component.exports